// Returns browser environment
export const env = () => (window as any).GH?.C?.env;

export const isProd = () => env() === "production";
